// 土耳其语(Turkish)
export default {
  coinSpecialOffer: "HT Parası Yükleme Özel Teklifi",
  buySomeAndGetExtra: "Biraz satın al ve ekstra kazan!",
  balance: "Balans",
  coins: "{number} para",
  coin: "{number} para",
  extraCoins: "{number} ekstra para",
  continue: "Devam Et",
  byToppingUpYouAgree: "Yükleyerek sözleşmeyi kabul etmiş olursun",
  topUpAgreement: "[Yükleme sözleşmesi]",
  htCoin: "HT Parası",
  scanCodeToLog: "Giriş için Kodu Tara",
  bindYourHelloTalkAccount:
    "Kodu tarayarak giriş yapmak için HelloTalk uygulamasını kullan. HelloTalk hesabını bağla ve yükle.",
  itemSelection: "Öğe seçimi",
  paymentAmount: "Tutar",
  topUpSuccessful: "Yükleme başarılı👏",
  totalCoinsNumber:
    "Kodu tarayarak giriş yapmak için HelloTalk uygulamasını kullan. HelloTalk hesabını bağla ve yükle.",
  ok: "OK",
  copyLinkToPay:
    "Lütfen bağlantıyı kopyala ve ödemeyi tamamlamak için HelloTalk uygulamasıyla aç.",
  paymentFailed: "Ödeme başarısız",
  creditCardPay: "PayPal veya kredi kartı ile ödeme yap",
  creditCard: "Kredi kartı",
};
